@if (visible) {
  <div class="backdrop" (click)="onClosed()"></div>
  <div class="uppercase mobile__menu" id="mobile-navigation-menu">
    @if (canSeeBuyingWindows) {
      <div
        id="mobile-nav-bw-toggle"
        class="menu__header fw-bold"
        (click)="buyingWindowMenuExpanded = !buyingWindowMenuExpanded"
      >
        Buying Window
        <i
          class="fas fa-angle-up"
          [ngClass]="{
            'fa-angle-up': buyingWindowMenuExpanded,
            'fa-angle-down': !buyingWindowMenuExpanded,
          }"
        ></i>
      </div>
      <div class="menu__item" [ngClass]="{ visible: buyingWindowMenuExpanded }">
        <a
          href="#"
          id="mobile-nav-bw-programs-link"
          class="link"
          (click)="bwProgramsClicked()"
          >Programs</a
        >
      </div>
      <div class="menu__item" [ngClass]="{ visible: buyingWindowMenuExpanded }">
        <a
          href="#"
          id="mobile-nav-bw-products-link"
          class="link"
          (click)="bwProductsClicked()"
          >All Products</a
        >
      </div>
      <div class="menu__item" [ngClass]="{ visible: buyingWindowMenuExpanded }">
        <a
          id="mobile-nav-bw-quick-shop-link"
          (click)="navigateToBWQuickOrder()"
          class="link"
          >Quick Shop</a
        >
      </div>
    }
    @if (canOrder) {
      <div
        id="mobile-nav-od-toggle"
        class="menu__header fw-bold"
        (click)="onDemandMenuExpanded = !onDemandMenuExpanded"
      >
        On Demand
        <i
          class="fas fa-angle-up"
          [ngClass]="{
            'fa-angle-up': onDemandMenuExpanded,
            'fa-angle-down': !onDemandMenuExpanded,
          }"
        >
        </i>
      </div>
      <div class="menu__item" [ngClass]="{ visible: onDemandMenuExpanded }">
        <a
          href="#"
          id="mobile-nav-od-programs-link"
          class="link"
          (click)="odProgramsClicked()"
          >Programs</a
        >
      </div>
      <div class="menu__item" [ngClass]="{ visible: onDemandMenuExpanded }">
        <a
          href="#"
          id="mobile-nav-od-products-link"
          class="link"
          (click)="odProductsClicked()"
          >All Products</a
        >
      </div>
      <div class="menu__item" [ngClass]="{ visible: onDemandMenuExpanded }">
        <a
          id="mobile-nav-od-quick-shop-link"
          class="link"
          (click)="navigateToODQuickOrder()"
          >Quick Shop</a
        >
      </div>
    }
    @if (clearanceUrl) {
      <div
        id="mobile-nav-clearance"
        class="menu__header fw-bold"
        role="link"
        (click)="navigateToClearance()"
      >
        Clearance
      </div>
    }
    @if (truckGraphicsUrl) {
      <div
        id="mobile-nav-truck-graphics"
        class="menu__header fw-bold"
        role="link"
        (click)="navigateToTruckGraphics()"
      >
        Truck Graphics
      </div>
    }
    @if (repackUrl) {
      <div
        id="mobile-nav-repack"
        class="menu__header fw-bold"
        role="link"
        (click)="navigateToRepack()"
      >
        Repack
      </div>
    }
    <div
      id="mobile-nav-account-toggle"
      class="menu__header fw-bold"
      (click)="accountMenuExpanded = !accountMenuExpanded"
    >
      Account
      <i
        class="fas fa-angle-up"
        [ngClass]="{
          'fa-angle-up': accountMenuExpanded,
          'fa-angle-down': !accountMenuExpanded,
        }"
      >
      </i>
    </div>
    <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
      <a
        routerLink="/account"
        id="mobile-nav-account-profile-link"
        (click)="onClosed()"
        class="link"
        >Profile</a
      >
    </div>
    @if (canSeeAddresses) {
      <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
        <a
          routerLink="/account/addresses"
          id="mobile-nav-account-addresses-link"
          (click)="onClosed()"
          class="link"
          >Address Book</a
        >
      </div>
    }
    @if (canShowPaymentPage) {
      <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
        <a
          routerLink="/account/payment-methods"
          id="mobile-nav-account-payment-methods-link"
          (click)="onClosed()"
          class="link"
          >Payment Methods</a
        >
      </div>
    }
    @if (canShowBudgets) {
      <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
        <a
          routerLink="/account/budgets"
          id="mobile-nav-account-budgets-link"
          (click)="onClosed()"
          class="link"
          >Budgets</a
        >
      </div>
    }
    @if (canSeeOrders) {
      <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
        <a
          routerLink="/account/orders"
          id="mobile-nav-account-order-history-link"
          (click)="onClosed()"
          class="link"
          >Order History</a
        >
      </div>
    }
    @if (canShowTransaction) {
      <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
        <a
          routerLink="/account/transactions"
          id="mobile-nav-account-transactions-link"
          (click)="onClosed()"
          class="link"
          >Credit Transactions</a
        >
      </div>
    }
    <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
      <a
        routerLink="/account/invoices"
        id="mobile-nav-account-invoices-link"
        (click)="onClosed()"
        class="link"
        >Invoices</a
      >
    </div>
    @if (canShowCustomRequest) {
      <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
        <a
          routerLink="/account/custom-request"
          id="mobile-nav-account-custom-request-link"
          (click)="onClosed()"
          class="link"
        >
          Custom Request
        </a>
      </div>
    }
    <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
      <a
        routerLink="/account/news"
        id="mobile-nav-account-news-link"
        (click)="onClosed()"
        class="link"
        >News</a
      >
    </div>
    @if (canSeeRepairRequests) {
      <div class="menu__item" [ngClass]="{ visible: accountMenuExpanded }">
        <a
          routerLink="/account/repair-requests"
          id="mobile-nav-account-repair-requests-link"
          (click)="onClosed()"
          class="link"
          >Repair Request</a
        >
      </div>
    }
    <div
      id="mobile-nav-support-toggle"
      class="menu__header fw-bold"
      (click)="supportMenuExpanded = !supportMenuExpanded"
    >
      Support
      <i
        class="fas fa-angle-up"
        [ngClass]="{
          'fa-angle-up': supportMenuExpanded,
          'fa-angle-down': !supportMenuExpanded,
        }"
      >
      </i>
    </div>
    <div class="menu__item" [ngClass]="{ visible: supportMenuExpanded }">
      <a
        href="mailto:HelpNest@hhglobal.com"
        id="mobile-nav-contact-support-link"
        target="_blank"
        (click)="onClosed()"
        class="link"
        >Contact Support</a
      >
    </div>
    <div class="menu__item" [ngClass]="{ visible: supportMenuExpanded }">
      <a
        routerLink="/faq"
        id="mobile-nav-faq-link"
        (click)="onClosed()"
        class="link"
        >Frequently Asked Questions</a
      >
    </div>
    <div class="menu__item" [ngClass]="{ visible: supportMenuExpanded }">
      <a
        [href]="perchUserGuideUrl"
        id="mobile-nav-perch-user-guide-link"
        target="_blank"
        (click)="onClosed()"
        class="link"
        >Perch User Guide</a
      >
    </div>
    @if (canShowCustomRequest) {
      <div class="menu__item" [ngClass]="{ visible: supportMenuExpanded }">
        <a
          [href]="customRequestUserGuideUrl"
          id="mobile-nav-custom-request-guide-link"
          target="_blank"
          (click)="onClosed()"
          class="link"
          >Custom Request User Guide</a
        >
      </div>
    }
    <div class="menu__item" [ngClass]="{ visible: supportMenuExpanded }">
      <a
        class="link"
        id="mobile-nav-sustainability-link"
        routerLink="/sustainability"
        >Sustainability</a
      >
    </div>
  </div>
}
